/* eslint-disable */
import {call, takeEvery, takeLatest, put, select} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {
  GET_LOCATION_SETTINGS_DATA,
  GET_LOCATION_SETTINGS_DATA_BY_ID,
  GET_LOCATION_SETTINGS_DATA_BY_ID_SUCCESS,
  GET_LOCATION_SETTINGS_DATA_SUCCESS,
  POST_LOCATION_SETTINGS_DATA,
  POST_LOCATION_SETTINGS_DATA_SUCCESS,
  UPDATE_LOCATION_SETTINGS_DATA,
  UPDATE_LOCATION_SETTINGS_DATA_SUCCESS,
  PAUSE_LOCATION,
  UNPAUSE_LOCATION,
  GET_CALLING_PHONE_SUCCESS,
  GET_CALLING_PHONE,
  PUBLISH_LOCATION,
  UPDATE_LOCATION_ACCOUNT_TEMPLATE,
  CREATE_STORE_HOLIDAYS_REQUEST,
  CREATE_STORE_HOLIDAYS_REQUEST_SUCCESS,
  SET_STATUS_BUTTON,
  GET_SPECIAL_HOURS,
  SET_SPECIAL_HOURS_LOADING,
  GET_SPECIAL_HOURS_SUCCESS,
  CREATE_SPECIAL_HOURS_SUCCESS,
  DELETE_SPECIAL_HOURS_SUCCESS,
  CREATE_SPECIAL_HOURS,
  DELETE_SPECIAL_HOURS,
  SET_DELETE_SPECIAL_HOURS_LOADING,
  SET_CREATE_SPECIAL_HOURS_LOADING,
  GET_AGGREGATION_PLATFORM_SETTINGS,
  GET_AGGREGATION_PLATFORM_SETTINGS_SUCCESS,
  SET_AGGREGATION_PLATFORM_SETTINGS_LOADING,
  UPDATE_SELF_DELIVERY_REPORT_EMAIL,
  GET_SELF_DELIVERY_REPORT_EMAIL,
  GET_SELF_DELIVERY_REPORT_EMAIL_SUCCESS,
  SET_SELF_DELIVERY_REPORT_EMAIL_LOADING
} from 'store/locationSettings/action';
import {
  getLocationSettingsDataApi,
  getLocationSettingsDataByIdApi,
  postLocationSettingsDataApi,
  updateLocationSettingsDataApi,
  pauseLocationApi,
  unpauseLocationApi,
  getCallingPhoneApi,
  publishLocationAPi,
  updateTemplateLocationApi,
  createStoreHolidaysApi,
  getSelfDeliveryReportEmailApi,
  updateSelfDeliveryReportEmailApi,
  getSpecialHoursApi,
  createSpecialHoursApi,
  deleteSpecialHoursApi
} from 'helpers/services/api/locationSettings';
import getAggregationPlatformSettingsApi from 'helpers/services/api/aggregationPlatforms';
import {GET_LOCATION_DATA, SET_SPECIAL_HOURS} from 'store/global/user/action';
import {
  cropOpeningHours,
  daysMomentPickerParser,
  daysPickerArrayParser
} from 'routes/App/settings/helpers';
import {getUsersLocations} from 'store/global/user/saga';
import {RUN_GET_PUBLISH_STATUS_JOB} from 'store/global/globalNotifications/action';
import {TASK_TYPE_SETTINGS_DATA_UPDATE} from 'store/global/globalNotifications/constants';

const locationId = ({user}) => user.locationId;
const configName = (state) => state.user.userData?.ConfigName;
const menuConfigId = (state) => state.user.activeLocation?.MenuConfigId;
const locationTaxPercents = (state) =>
  state.locationSettingsReducer.data.TaxPercents;
const locationAlcoholTax = (state) =>
  state.locationSettingsReducer.data.AlcoholTax;
const specialHours = (state) => state.locationSettingsReducer.specialHours;

export function* getLocationData({payload}) {
  try {
    const {data} = yield getLocationSettingsDataApi(payload);

    if (data) {
      yield put(GET_LOCATION_SETTINGS_DATA_SUCCESS(data));
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

export function* getLocationDataById() {
  try {
    const requestedId = yield select(locationId);
    const {data} = yield getLocationSettingsDataByIdApi(requestedId);
    const currentId = yield select(locationId);

    if (!data || requestedId !== currentId) {
      return;
    }

    data.WorkingDays = daysPickerArrayParser(
      daysMomentPickerParser(cropOpeningHours(data.OpeningHours))
    );

    data.DeliveryDays = daysPickerArrayParser(
      daysMomentPickerParser(cropOpeningHours(data.DeliveryHours || []))
    );

    yield put(GET_LOCATION_SETTINGS_DATA_BY_ID_SUCCESS(data));
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

export function* updateLocationData({
  payload: {payload, successCallback, errorCallback}
}) {
  try {
    const id = yield select(locationId);

    const data = yield updateLocationSettingsDataApi(id, payload);

    if (data || data.status === 204) {
      // Prefer API body; fall back to request payload for immediate UI sync (e.g. 204)
      yield put(
        UPDATE_LOCATION_SETTINGS_DATA_SUCCESS(data?.data || payload || {})
      );
      yield put(GET_LOCATION_DATA());
      yield put(GET_LOCATION_SETTINGS_DATA_BY_ID({noLoader: true}));
      if (successCallback) successCallback();
    }
  } catch (error) {
    errorCallback();
    yield put(SET_STATUS_BUTTON(false));
    console.log('SAGA ERROR', error);
  }
}

function* applyLocationPauseChange(
  api,
  {payload, optimisticPayload, successCallback, errorCallback}
) {
  try {
    const id = yield select(locationId);
    const response = yield call(api, id, payload);

    if (response) {
      yield put(UPDATE_LOCATION_SETTINGS_DATA_SUCCESS(optimisticPayload || {}));
      yield put(GET_LOCATION_DATA());
      yield put(GET_LOCATION_SETTINGS_DATA_BY_ID({noLoader: true}));
      if (successCallback) successCallback();
    }
  } catch (error) {
    if (typeof errorCallback === 'function') errorCallback();
    yield put(SET_STATUS_BUTTON(false));
    console.log('SAGA ERROR', error);
  }
}

export function* pauseLocationSettings({payload}) {
  yield call(applyLocationPauseChange, pauseLocationApi, payload);
}

export function* unpauseLocationSettings({payload}) {
  yield call(applyLocationPauseChange, unpauseLocationApi, payload);
}

export function* postLocation({payload: {payload, successCallback}}) {
  try {
    const {data} = yield postLocationSettingsDataApi(payload);
    if (data || data === '') {
      yield put(POST_LOCATION_SETTINGS_DATA_SUCCESS(data));
      yield put(GET_LOCATION_DATA());
      if (successCallback) successCallback();
    }
  } catch (error) {
    if (successCallback) successCallback();
    console.log('SAGA ERROR', error);
  }
}

export function* getCallingPhone({payload}) {
  try {
    const {data} = yield getCallingPhoneApi(payload.countryCode);

    if (data || data === '') {
      yield put(GET_CALLING_PHONE_SUCCESS(data));
      yield put(GET_LOCATION_DATA());
    }
  } catch (error) {
    toast.error(`Error occurred - please try again [${error}]`);
  }
}

export function* publishLocation({payload}) {
  const {preCallback, postCallBack, errorCallback = () => {}} = payload;
  try {
    preCallback();
    yield put(
      RUN_GET_PUBLISH_STATUS_JOB({SyncType: TASK_TYPE_SETTINGS_DATA_UPDATE})
    );

    const menuId = yield select(menuConfigId);

    yield publishLocationAPi(menuId);
  } catch (error) {
    errorCallback();
    console.log('SAGA ERROR', error);
  }
}

export function* updateTemplateLocation({payload}) {
  try {
    const id = yield select(locationId);

    yield updateTemplateLocationApi(id, payload);
    yield getUsersLocations();
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

export function* createStoreHolidays({payload}) {
  try {
    const id = yield select(locationId);

    const {data} = yield createStoreHolidaysApi(id, payload);
    if (data) {
      data.WorkingDays = daysPickerArrayParser(
        daysMomentPickerParser(cropOpeningHours(data.OpeningHours))
      );
      yield put(CREATE_STORE_HOLIDAYS_REQUEST_SUCCESS(data));
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

const toSelfDeliveryReportEmailState = (data) => {
  const info = data?.data || data || {};
  return {
    email: info.email || info.Email || '',
    bankAccountConnected: Boolean(info.bankAccountConnected),
    bankAccountLast4: info.bankAccountLast4 || null,
    companyFound: Boolean(info.companyFound)
  };
};

export function* updateSelfDeliveryReportEmail({payload}) {
  try {
    const id = yield select(locationId);
    const {newEmail, locationId: payloadLocationId, successCallback} =
      payload || {};

    const requestedId = payloadLocationId || id;
    const {data} = yield updateSelfDeliveryReportEmailApi(requestedId, {
      email: newEmail
    });
    const currentId = yield select(locationId);
    if (requestedId !== currentId) {
      if (successCallback) {
        successCallback();
      }
      return;
    }

    const info = data?.data || data || {};
    if (info.sentToSupport || info.SentToSupport) {
      toast.success('Your request has been sent to Support');
    } else {
      yield put(
        GET_SELF_DELIVERY_REPORT_EMAIL_SUCCESS(
          toSelfDeliveryReportEmailState(data)
        )
      );
      toast.success('Self-delivery report email updated');
    }
    if (successCallback) {
      successCallback();
    }
  } catch (error) {
    toast.error('Failed to update email. Please try again.');
    if (payload?.errorCallback) {
      payload.errorCallback();
    }
    console.log('SAGA ERROR', error);
  }
}

export function* getSelfDeliveryReportEmail() {
  try {
    const id = yield select(locationId);
    yield put(SET_SELF_DELIVERY_REPORT_EMAIL_LOADING(true));
    const {data} = yield getSelfDeliveryReportEmailApi(id);
    yield put(
      GET_SELF_DELIVERY_REPORT_EMAIL_SUCCESS(
        toSelfDeliveryReportEmailState(data)
      )
    );
  } catch (error) {
    yield put(GET_SELF_DELIVERY_REPORT_EMAIL_SUCCESS(null));
    console.log('SAGA ERROR', error);
  } finally {
    yield put(SET_SELF_DELIVERY_REPORT_EMAIL_LOADING(false));
  }
}

export function* getSpecialHours() {
  try {
    const id = yield select(locationId);
    const {data} = yield getSpecialHoursApi(id);
    if (data?.data) {
      yield put(GET_SPECIAL_HOURS_SUCCESS(data.data));
    }
    yield put(SET_SPECIAL_HOURS_LOADING(false));
  } catch (error) {
    console.log('SAGA ERROR', error);
    yield put(SET_SPECIAL_HOURS_LOADING(false));
  }
}

export function* createSpecialHours({payload}) {
  try {
    const id = yield select(locationId);
    const specialHoursFromState = yield select(specialHours);
    const {data} = yield createSpecialHoursApi(id, payload?.body);
    if (data?.data) {
      yield put(CREATE_SPECIAL_HOURS_SUCCESS(data.data));
      if (payload?.successCallback) payload.successCallback();
      yield put(SET_SPECIAL_HOURS([...specialHoursFromState, data.data]));
      toast.success('Special hours created successfully');
    }
    yield put(SET_CREATE_SPECIAL_HOURS_LOADING(false));
  } catch (error) {
    console.log('SAGA ERROR', error);
    yield put(SET_CREATE_SPECIAL_HOURS_LOADING(false));
  }
}

export function* deleteSpecialHours({payload}) {
  try {
    const id = yield select(locationId);
    const specialHoursFromState = yield select(specialHours);
    const {data} = yield deleteSpecialHoursApi(id, payload);
    if (data === '' || data?.status === 204) {
      yield put(DELETE_SPECIAL_HOURS_SUCCESS(payload));
      yield put(
        SET_SPECIAL_HOURS([
          ...specialHoursFromState.filter((hour) => hour.id !== payload)
        ])
      );
      toast.success('Special hours deleted successfully');
    }
    yield put(SET_DELETE_SPECIAL_HOURS_LOADING(false));
  } catch (error) {
    console.log('SAGA ERROR', error);
    yield put(SET_DELETE_SPECIAL_HOURS_LOADING(false));
  }
}

export function* getAggregationPlatformSettings() {
  try {
    const id = yield select(locationId);
    const {data} = yield getAggregationPlatformSettingsApi(id);
    if (data?.data) {
      yield put(GET_AGGREGATION_PLATFORM_SETTINGS_SUCCESS(data.data));
    }
    yield put(SET_AGGREGATION_PLATFORM_SETTINGS_LOADING(false));
  } catch (error) {
    yield put(SET_AGGREGATION_PLATFORM_SETTINGS_LOADING(false));
    console.log('SAGA ERROR', error);
  }
}

function* locationSettingsSaga() {
  yield takeEvery(GET_LOCATION_SETTINGS_DATA, getLocationData);
  yield takeEvery(UPDATE_LOCATION_SETTINGS_DATA, updateLocationData);
  yield takeEvery(PAUSE_LOCATION, pauseLocationSettings);
  yield takeEvery(UNPAUSE_LOCATION, unpauseLocationSettings);
  yield takeEvery(POST_LOCATION_SETTINGS_DATA, postLocation);
  yield takeEvery(GET_CALLING_PHONE, getCallingPhone);
  yield takeLatest(GET_LOCATION_SETTINGS_DATA_BY_ID, getLocationDataById);
  yield takeEvery(PUBLISH_LOCATION, publishLocation);
  yield takeEvery(UPDATE_LOCATION_ACCOUNT_TEMPLATE, updateTemplateLocation);
  yield takeEvery(CREATE_STORE_HOLIDAYS_REQUEST, createStoreHolidays);
  yield takeEvery(
    UPDATE_SELF_DELIVERY_REPORT_EMAIL,
    updateSelfDeliveryReportEmail
  );
  yield takeEvery(GET_SELF_DELIVERY_REPORT_EMAIL, getSelfDeliveryReportEmail);
  yield takeEvery(GET_SPECIAL_HOURS, getSpecialHours);
  yield takeEvery(CREATE_SPECIAL_HOURS, createSpecialHours);
  yield takeEvery(DELETE_SPECIAL_HOURS, deleteSpecialHours);
  yield takeEvery(
    GET_AGGREGATION_PLATFORM_SETTINGS,
    getAggregationPlatformSettings
  );
}

export default locationSettingsSaga;
